import { actionTypes } from "../../../types";

const initialState = {
    loading: false,
    status: '',
    message: '',
    data: [],
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.STREAM_VIDEO_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.STREAM_VIDEO_SUCCESS:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
                data: action?.payload?.response
            }
        case actionTypes.STREAM_VIDEO_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
            }
        case actionTypes.STREAM_VIDEO_RESET:
            return {
                ...state,
                status: '',
                message: ''
            }
        case actionTypes.STREAM_VIDEO_RESET_ALL:
            return initialState
        default:
            return state;
    }
};
